import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OrderDetailsState } from '../states/orderDetails.state';
import { Position, PerviousTransaction, PositionDataAsArray } from '../../models/position.model';
import { Delivery } from 'src/app/models/delivery.model';
import { regex } from '../../../config/regex-config';
// eslint-disable-next-line no-var
declare var jsonpath: any;
import { JSON_PATHS } from 'src/app/common/constants/mapping.defines';
import isEmpty from 'lodash/isEmpty';
import forOwn from 'lodash/forOwn';
import values from 'lodash/values';
import flattenDeep from 'lodash/flattenDeep';
/* eslint-disable */
/** getorderDetailsState */
export const getorderDetailsState = createFeatureSelector<OrderDetailsState>('orderDetailsState');
/** getDelivery */
export const getDelivery = createSelector(
    getorderDetailsState, (state: OrderDetailsState) => state && state.delivery);
/** getRefreshUserData */
export const getRefreshUserData = createSelector(
    getorderDetailsState, (state: OrderDetailsState) => state && state.refreshUserData);
/** getOriginalAndChangedPositions */
export const getOriginalAndChangedPositions = createSelector(
    getorderDetailsState, (state: OrderDetailsState) => state && { positions: state.delivery && state.delivery.positions, changedPosition: state.changedPosition, tariffName: state.delivery.tariffName });
/** getMoreInfo */
export const getMoreInfo = createSelector(
    getorderDetailsState, (state: OrderDetailsState) => state && state.moreInfo);
/** getLoggedIn */
export const getLoggedIn = createSelector(
    getorderDetailsState, (state: OrderDetailsState) => state && state.loggedIn);
/** geterrorObject */
export const geterrorObject = createSelector(
    getorderDetailsState, (state: OrderDetailsState) => state && state.errorObject);
/** getTariffName */
export const getTariffName = createSelector(
    getDelivery, (state: Delivery) => state && state.tariffName);
/** getPositions */
export const getPositions = createSelector(
    getDelivery, (state: Delivery) => state && state.positions);
/** getorderDate */
export const getorderDate = createSelector(
    getDelivery, (state: Delivery) => state && state.orderDate);
/** getPositionSelected */
export const getPositionSelected = createSelector(
    getorderDetailsState, (state: OrderDetailsState) => state && state.changedPosition);
/** getOrderId */
export const getOrderId = createSelector(
    getorderDetailsState, (state: OrderDetailsState) => state && state.userCredentials && state.userCredentials.orderNumber);
/** getUserCredentials */
export const getUserCredentials = createSelector(
    getorderDetailsState, (state: OrderDetailsState) => state && state.userCredentials);
/** getSalesChannel */
export const getSalesChannel = createSelector(
    getDelivery, (state: Delivery) => state && state.salesChannel);
/** getReturnsEntitled */
export const getReturnsEntitled = createSelector(
    getPositionSelected, (positions: { [key: string]: Position[] }) => positions && positions[Object.keys(positions)[0]][0].returnsEntitled);
/** getReturnsEntitledFromPosition */
    export const getReturnsEntitledFromPosition = createSelector(
    getPositions, (positions: { [key: string]: Position[] }) => {

    if (positions && positions[Object.keys(positions)[0]]

    && positions[Object.keys(positions)[0]][0]

    && positions[Object.keys(positions)[0]][0].returnsEntitled) {

    return positions[Object.keys(positions)[0]][0].returnsEntitled;
    } else {

    return null;
    }
    });
    /** getMsisdn */
export const getMsisdn = createSelector(
    getPositionSelected, (positions: { [key: string]: Position[] }) => {

        const simNumberRegex = new RegExp(regex.simNumber);

        let hardwarePosition: Position = null;

        let simPosition: Position  = null;

        forOwn(positions, (value, key) => {

            if (simNumberRegex.test(positions[key][0].articleNumber)) {

                simPosition = positions[key][0];
            } else if (!simNumberRegex.test(positions[key][0].articleNumber)) {

                hardwarePosition = positions[key][0];
            }
        });

        return (simPosition && simPosition.msisdn) ? simPosition.msisdn : (hardwarePosition && hardwarePosition.msisdn) ? hardwarePosition.msisdn : null;
    });

/** selectArticleNumber */
export const selectArticleNumber = createSelector(
    getPositionSelected, (positions: { [key: string]: Position[] }) => {
        const simNumberRegex = new RegExp(regex.simNumber);

        for (const key in positions) {

            if (positions.hasOwnProperty(key) && !simNumberRegex.test(positions[key][0].articleNumber)) {

                return positions[key][0].articleNumber;
            }
        }

        return null;
    });
/** selectSIMArticleNumber */
export const selectSIMArticleNumber = createSelector(
    getPositionSelected, (positions: { [key: string]: Position[] }) => {

        const simNumberRegex = new RegExp(regex.simNumber);

        for (const key in positions) {

            if (positions.hasOwnProperty(key) && simNumberRegex.test(positions[key][0].articleNumber)) {

                return positions[key][0].articleNumber;
            }
        }

        return null;
    });
/** getSimPosition */
export const getSimPosition = createSelector(
        getDelivery, (delivery: Delivery) => {

            const simNumberRegex = new RegExp(regex.simNumber);
            const positions = delivery.positions;
            const groupedPositions = jsonpath.query(delivery.groups, JSON_PATHS.NIL.PREVIOUS_TRANSACTIONS.GET_ALL_POSTION_WITH_TIMESTAMP);

            for (const key in positions) {

                if (positions.hasOwnProperty(key) && simNumberRegex.test(positions[key][0].articleNumber)) {

                    return positions[key][0];
                }
            }
            for (const key in groupedPositions) {
                if (groupedPositions.hasOwnProperty(key) && simNumberRegex.test(groupedPositions[key].articleNumber)) {

                    return groupedPositions[key];
            }
        }

            return null;
        });
        /** selectTariffCode */
export const selectTariffCode = createSelector(
    getDelivery, (state: Delivery) => state && state.tariffCode);
/** selectCustomerStatus */
export const selectCustomerStatus = createSelector(
    getDelivery, (state: Delivery) => state && state.customerStatus);
/** selectCustomerType */
export const selectCustomerType = createSelector(
    getDelivery, (state: Delivery) => state && state.mappedCustomerType);
/** getTrackinglink */
export const getTrackinglink = createSelector(
    getorderDetailsState, (state: OrderDetailsState) => state && state.delivery && state.delivery.logistics && state.delivery.logistics.trackingLink);
/** getPositionByArticleNumber */
export const getPositionByArticleNumber = (articleNumber) => createSelector(
    getPositions, (positions) => positions && positions[articleNumber] && positions[articleNumber][0]);
/** getDefectReasonText */
export const getDefectReasonText = createSelector(
    getPositionSelected, (positions) => {
        const simNumberRegex = new RegExp(regex.simNumber);
        for (const key in positions) {

            if (positions.hasOwnProperty(key) && !simNumberRegex.test(positions[key][0].articleNumber)) {

                return positions[key][0].returnReasonText;
            }
        }
    },
);
/** getFilteredPreviousTransactions */
export const getFilteredPreviousTransactions = (articleNumber: string, filterParams?: {
    /** imei */
    imei?: string;
    /** transactionName */
    transactionName?: string;
}) => createSelector(
    getDelivery, (delivery: Delivery): PerviousTransaction[] => {
        let JsonPath;
        if (articleNumber && !filterParams) {
            JsonPath = JSON_PATHS.NIL.PREVIOUS_TRANSACTIONS.ARTICLE_NUMBER(articleNumber);
        }
        if (filterParams) {
            if (articleNumber && filterParams.imei) {
                JsonPath = JSON_PATHS.NIL.PREVIOUS_TRANSACTIONS.ARTICLE_NUMBER_IMEI(articleNumber, filterParams.imei);
            }
            if (articleNumber && filterParams.transactionName) {
                JsonPath = JSON_PATHS.NIL.PREVIOUS_TRANSACTIONS.ARTICLE_NUMBER_TRANSACTION_NAME(articleNumber, filterParams.transactionName);
            }
            if (articleNumber && filterParams.transactionName && filterParams.imei) {
                JsonPath = JSON_PATHS.NIL.PREVIOUS_TRANSACTIONS.ARTICLE_NUMBER_TRANSACTION_NAME_IMEI(articleNumber, filterParams.transactionName, filterParams.imei);
            }
        }

        const previousTransactions = jsonpath.query(delivery, JsonPath);

        return previousTransactions[0];

    });
    /** getOnePositionFromPositionsOrGroup */
export const getOnePositionFromPositionsOrGroup = createSelector(

    getDelivery, (state: Delivery) => {
        const timeStampGrouping = state.groups[Object.keys(state.groups)[0]];
        const positions = state.positions[Object.keys(state.positions)[0]];

        return state && ((positions && positions[0]) ||
            (timeStampGrouping && timeStampGrouping[Object.keys(timeStampGrouping)[0]][0].position));
    });
/** getAllPositionFromPositionsOrGroup */
export const getAllPositionFromPositionsOrGroup = createSelector(

    getDelivery, (state: Delivery) => {

        let positions = null;

        if (state) {

            const tempPositions = jsonpath.query(state.groups, JSON_PATHS.NIL.PREVIOUS_TRANSACTIONS.GET_ALL_POSTION_WITH_TIMESTAMP);

            positions = state.positions;

            if (isEmpty(positions)) {

                tempPositions.forEach((pos) => {
                    positions[pos.articleNumber] = [pos];
                });
            } else if (!isEmpty(positions) && tempPositions && tempPositions.length) {

                tempPositions.forEach((pos) => {
                    positions[pos.articleNumber] = [pos];
                });
            }
        }

        return positions;
    });
/** getAllPositionsAndNormalPositions */
    export const getAllPositionsAndNormalPositions = createSelector(

        getDelivery, (state: Delivery): {
            /** normalPosition */
            normalPosition: { [key: string]: Position[] },
            /** allPositions */
            allPositions: { [key: string]: Position[] },
            /** groupPositions */
            groupPositions: { [key: string]: Position[] },
         } => {

            let positions: { [key: string]: Position[] } = null;

            const groupPositions: { [key: string]: Position[] } = {};

            if (state) {

                const tempPositions: Position[] = jsonpath.query(state.groups, JSON_PATHS.NIL.PREVIOUS_TRANSACTIONS.GET_ALL_POSTION_WITH_TIMESTAMP);

                positions = state.positions;

                if (isEmpty(positions)) {

                    tempPositions.forEach((pos) => {
                        positions[pos.articleNumber] = [pos];
                        groupPositions[pos.articleNumber] = [pos];

                    });

                } else if (!isEmpty(positions) && tempPositions && tempPositions.length) {

                    tempPositions.forEach((pos) => {
                        positions[pos.articleNumber] = [pos];
                        groupPositions[pos.articleNumber] = [pos];
                    });
                }

                return {
                   normalPosition: state.positions,
                   allPositions: positions,
                   groupPositions,
                };
            }

            return null;
        });
/** getLogisticsPositionAndReturnsEntitled */
export const getLogisticsPositionAndReturnsEntitled = createSelector(
    getDelivery, (state: Delivery) => {
        const timeStampGrouping = state.groups[Object.keys(state.groups)[0]];
        const positions = state.positions[Object.keys(state.positions)[0]];

        return state && {
            position: state.logistics.position,
            returnsEntitled: ((positions && positions[0].returnsEntitled) || (timeStampGrouping && timeStampGrouping[Object.keys(timeStampGrouping)[0]][0].position.returnsEntitled)),
        };
    });
/** getPreviousTransactionsWithForwardToAgent */
export const getPreviousTransactionsWithForwardToAgent = (articleNumber: string) => createSelector(
    getPositions, (positions: { [key: string]: Position[] }): PerviousTransaction[] => {

        const positionsForArticleNumber: Position[] = positions[articleNumber];

        if (positionsForArticleNumber && positionsForArticleNumber.length) {

            let previousTransactions: PerviousTransaction[] = [];

            positionsForArticleNumber.forEach((position: Position) => {

                previousTransactions = position.previousTransactions ? previousTransactions.concat(position.previousTransactions) : [];
            });

            return previousTransactions.filter((previousTransaction) => previousTransaction.forwardToAgent);
        }

        return [];
    });
/** getAllPreviousTransactions */
export const getAllPreviousTransactions = (articleNumber: string) => createSelector(
    getPreviousTransactionsWithForwardToAgent(articleNumber), getFilteredPreviousTransactions(articleNumber), (prevWithForwardToAgent, prevWithoutForwardToAgent): PerviousTransaction[] => {

        return prevWithoutForwardToAgent ? prevWithForwardToAgent.concat(prevWithoutForwardToAgent) : prevWithForwardToAgent;
    });
/** getLogisticsPosition */
export const getLogisticsPosition = createSelector(
    getDelivery, (delivery: Delivery): number => delivery.logistics.position);
/** getUserAddressData */
export const getUserAddressData = createSelector(
    getorderDetailsState, (state: OrderDetailsState) => state && state.userAddressData);
/** getEnterpriseValue */
export const getEnterpriseValue = createSelector(
    getDelivery, (delivery: Delivery) => delivery && delivery.isEnterprise);
    /** getAllPositionsAndGroups */
    export const getAllPositionsAndGroups = createSelector(
        getDelivery, (state: Delivery) => {
            let positions = null;
            let groups = null;
            if (state) {
                groups = state.groups;
                positions = state.positions;
            }

            return {positions: positions, groups: groups,
            };
        });
/** getClassifiedPositionsSelected */
export const getClassifiedPositionsSelected = createSelector(getPositionSelected, (state): PositionDataAsArray  => {
    // tslint:disable-next-line: prefer-const
    let positions = state;
    const allClassifiedPositions: {
        /** hardwareObjects */
        hardwareObjects: { [key: string]: Position[]; },
        /** simObjects */
        simObjects: { [key: string]: Position[]; },
        /** accessoriesObjects */
        accessoriesObjects: { [key: string]: Position[]; },
    } = {
        hardwareObjects: {},
        simObjects: {},
        accessoriesObjects: {},
    };
    const simArticleNumberRegex = new RegExp(regex.simArticleNumber);
    const hardwareArticleNumberRegex = new RegExp(regex.hardwareArticleNumber);
    let articleNumberPositions: Position[] = null;

    for (const key in positions) {
        if (positions.hasOwnProperty(key)) {
            articleNumberPositions = positions[key];
                if (simArticleNumberRegex.test(articleNumberPositions[0].articleNumber)) {

                    allClassifiedPositions.simObjects[key] = articleNumberPositions;
                } else if (hardwareArticleNumberRegex.test(articleNumberPositions[0].articleNumber)) {
                    allClassifiedPositions.hardwareObjects[key] = articleNumberPositions;

                } else {
                    allClassifiedPositions.accessoriesObjects[key] = articleNumberPositions;
            }
        }
    }

    return {
        accessories: flattenDeep(values(allClassifiedPositions.accessoriesObjects)) || [],
        sims: flattenDeep(values(allClassifiedPositions.simObjects)) || [],
        hardwares: flattenDeep(values(allClassifiedPositions.hardwareObjects)) || [],
    };
});
/** getClassifiedPositions */
export const getClassifiedPositions = (type: 'groups' | 'positions') => createSelector(getAllPositionsAndGroups, (state) => {
    let positions = state[type];
    const allClassifiedPositions: {
        /** hardwareObjects */
        hardwareObjects: { [key: string]: Position[]; },
        /** simObjects */
        simObjects: { [key: string]: Position[]; },
        /** accessoriesObjects */
        accessoriesObjects: { [key: string]: Position[]; },
    } = {
        hardwareObjects: {},
        simObjects: {},
        accessoriesObjects: {},
    };
    const simArticleNumberRegex = new RegExp(regex.simArticleNumber);
    const hardwareArticleNumberRegex = new RegExp(regex.hardwareArticleNumber);
    if (type === 'groups') {
        const groupedPositions = jsonpath.query(positions,
            JSON_PATHS.NIL.PREVIOUS_TRANSACTIONS.GET_ALL_POSTION_WITH_TIMESTAMP);
            const newGroups:  { [key: string]: Position[]; } = {};
            if (groupedPositions) {
                groupedPositions.forEach((pos) => {
                    if (!newGroups[pos.articleNumber]) {
                      newGroups[pos.articleNumber] = [pos];

                    } else {
                        newGroups[pos.articleNumber].push(pos);
                    }

                });
            }
            positions = newGroups;
    }
    let articleNumberPositions: Position[] = null;

    for (const key in positions) {
        if (positions.hasOwnProperty(key)) {
            articleNumberPositions = positions[key];
                if (simArticleNumberRegex.test(articleNumberPositions[0].articleNumber)) {

                    allClassifiedPositions.simObjects[key] = articleNumberPositions;
                } else if (hardwareArticleNumberRegex.test(articleNumberPositions[0].articleNumber)) {
                    allClassifiedPositions.hardwareObjects[key] = articleNumberPositions;

                } else {
                    allClassifiedPositions.accessoriesObjects[key] = articleNumberPositions;
            }
        }
    }

    return allClassifiedPositions;
});
/** checkGroupsWithTransactionNames */
export const checkGroupsWithTransactionNames = (names: string[]) =>
    createSelector(
        getClassifiedPositions('groups'),
        ({ simObjects, hardwareObjects, accessoriesObjects }) => {
            // tslint:disable-next-line: prefer-const
            let positionsArray = [ ...flattenDeep(values(simObjects)),
                ...flattenDeep(values(accessoriesObjects)),
                ...flattenDeep(values(hardwareObjects))];

            return positionsArray.some((pos: Position) => {
                if (pos.previousTransactions) {
                    return pos.previousTransactions.some((elm) =>
                        names.includes(elm.transactionName),
                    );
                }

                return false;
            });
        },
    );
/** getCIDAndCustomerType */
export const getCIDAndCustomerType = createSelector(
    getorderDetailsState, (state: OrderDetailsState) => state && {customerType: state.delivery && state.delivery.mappedCustomerType, c_id: state.c_id });
/** getCameFromOverview */
export const getCameFromOverview = createSelector(
    getorderDetailsState, (state: OrderDetailsState) => state && state.cameFromOverview );
/** getEmailAddress */
export const getEmailAddress = createSelector(
    getDelivery, (state: Delivery) => state && state.emailAddress );
/** getSalesOrderType */
export const getSalesOrderType = createSelector(
    getDelivery, (state: Delivery) => state && state.salesOrderType );
/** getShipToParty */
export const getSenderParty = createSelector(
    getDelivery, (state: Delivery) => state && state.senderParty );
/** getShipToContactPoint */
export const getSenderContactPoints = createSelector(
    getDelivery, (state: Delivery) => state && state.senderContactPoints );
/** getShipmentNumber */
export const getShipmentNumber = createSelector(
    getDelivery, (state: Delivery) => state && state.shipmentNumber );
/** getPostalShopping */
export const getPostalShopping = createSelector(
    getDelivery, (state: Delivery) => state && state.isPostalShopping );
/** getPostalShoppingScenario */
export const getPostalShoppingScenario = createSelector(
    getorderDetailsState, (state: OrderDetailsState) => state && state.postalShoppingScenario );
    /** getPostalShoppingScenario */
export const getPostalShoppingCustomPositions = createSelector(
    getDelivery, (state: Delivery) => state && state.customPostalShoppingPositions );
